<template>
  <div class="hello">
    <div class="title">
      <div class="logo">
        <img src="@/assets/logo.png">
      </div>
      <div>
        <span
          @click="handleProduct('#company')"
          :class="index === '#company' ? 'selected' : ''"
          >公司简介</span
        >
        <span
          @click="handleProduct('#product')"
          :class="index === '#product' ? 'selected' : ''"
          >商城介绍</span
        >
        <span
          @click="handleProduct('#contact')"
          :class="index === '#contact' ? 'selected' : ''"
          >联系我们</span
        >
      </div>
    </div>
    <div class="content">
      <img src="@/assets/company.png" id="company" />
      <img src="@/assets/product.png" id="product" />
      <img src="@/assets/footer.png" id="contact" />
    </div>
    <footer>
      Copyright ©2022 杭州冠力信息技术有限公司
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备2022016249号</a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      index: '#company'
    }
  },
  methods: {
    handleProduct (item) {
      this.index = item
      let scrollTop = document.documentElement.scrollTop
      let top = document.querySelector(item).offsetTop - scrollTop - 90
      window.scrollBy({ top, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.hello {
  width: 100%;
  margin: 0;
  padding: 0;
}
.title {
  height: 90px;
  display: flex;
  background-color: #ffffff;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  align-items: center;
  position: fixed;
  top: 0;
}
.title .logo img {
  width: 237px;
  height: 30px;
  margin-left: 330px;
}
.title div {
  display: flex;
}
.title div span {
  margin-right: 80px;
  cursor: pointer;
  padding-bottom: 12px;
}
.hello div {
  width: 100%;
}
.hello div img {
  width: 100%;
  display: block;
}
.content {
  margin-top: 90px;
}
.selected {
  color: #EE6C28;
  font-size: 16px;
  border-bottom: 4px solid #EE6C28;
}
footer {
  height: 60px;
  background: #333333;
  text-align: center;
  line-height: 60px;
  color: #666;
  font-size: 14px;
}
footer a {
  color: #666;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue